var SimulateRemoteVideoService = /** @class */ (function () {
    function SimulateRemoteVideoService(virtualDeviceVideoService) {
        this.virtualDeviceVideoService = virtualDeviceVideoService;
    }
    SimulateRemoteVideoService.prototype.getVideoUrl = function (tag) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.virtualDeviceVideoService.getVideoUrl(0, tag).toPromise().then(function (videoUrl) {
                resolve(videoUrl);
            }, function (err) {
                reject(err);
            });
        });
    };
    return SimulateRemoteVideoService;
}());
export { SimulateRemoteVideoService };
